module.exports = __webpack_public_path__ + "img/s-1.7b4dbaf3.png";